"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const order_fragment_1 = __importDefault(require("../fragments/order.fragment"));
const query = (0, client_1.gql) `
  query order($orderId: String) {
    order(orderId: $orderId) {
      _id
      userId
      printed
      email
      sharing {
        email
        phoneNumber
        tickets
        upgrades
        eventName
        orderId
        status
      }
      parentOrderDetails {
        email
        phoneNumber
        eventName
      }
      user {
        email
        firstName
        lastName
        phoneNumber
        userProfile {
          imageUrl
        }
      }
      parentOrderId
      orgId
      eventId
      seasonId
      hidden
      event {
        _id
        name
        subtitle
        seasonId
        isMultipleDays
        posterImageUrl
        sendQRCode
        ...EventPromotions
        ticketTypes {
          _id
          isTicketSharing
        }
        upgrades {
          _id
          isAddOnsSharing
        }
        performances {
          schedule {
            doorsAt
            startsAt
          }
        }
        schedule {
          startsAt
          endsAt
        }
        venueId
        venue {
          _id
          name
          address {
            state
            city
            timezone
          }
        }
      }
      season {
        _id
        name
        subtitle
        posterImageUrl
        sendQRCode
        performances {
          schedule {
            doorsAt
            startsAt
          }
        }
        schedule {
          startsAt
          endsAt
        }
        venueId
        venue {
          _id
          name
          address {
            state
            city
            timezone
          }
        }
      }
      processingFee {
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
          __typename
        }
        amount
      }
      promoterFee {
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
          __typename
        }
        amount
      }
      feeIds
      fees {
        _id
        name
        orgId
        eventId
        type
        value
        appliedTo
        appliedBy
        minAppliedToPrice
        maxAppliedToPrice
        filters
        createdBy
        createdAt
        updatedBy
        updatedAt
        disabled
        amount
      }
      createdAt
      stripeChargeId
      stripeCharge {
        brand
        last4
      }
      state
      refundedAmount
      refundReason
      promotionCode
      discountCode
      discountAmount
      type
      tax
      channel
      ipAddress
      address {
        lat
        lng
        zip
      }
      customFields {
        _id
        label
        value
        customFieldId
        type
      }
      createdBy
      creator {
        firstName
        lastName
      }
      qrCodeUrl
      orderIntegrationResponse {
        success
        title
        message
        statusCode
        actionType
        createdAt
        orderType
      }
      payments {
        _id
        paymentIntentId
        amount
        transferAmount
        feeAmount
        feeIds
        createdAt
        createdBy
        promotionCode
        paymentMethodType
      }
      ...OrderTickets
      ...OrderUpgrades
    }
  }
  ${order_fragment_1.default.fragments.tickets}
  ${order_fragment_1.default.fragments.upgrades}
  ${order_fragment_1.default.fragments.promotions}
`;
exports.default = query;
//# sourceMappingURL=order.query.js.map